<div class="w-100 h-100 container-fluid" style="min-width: 500px;">
  <span class="font-weight-bold">{{supplierName}}</span><br />
  <span class="font-weight-bold mb-2">{{type}} - 4 Quarter</span>
  <div id="chart" #chartContainer></div>
</div>
